import { useNavigate, useParams } from "react-router-dom";
import { useLang } from "../../hooks/useLangPath";
import { useEffect, useState } from "react";
import { InnovationServices } from "../../services/innovation.service";
import { InnovationDataType } from "../../interface/site.interface";
import styles from "./newsDetail.module.scss";
import MobileAppSection from "../../components/pages/home/mobile-app-section/MobileAppSection";
import Spinner from "../../components/shared/spinner/Spinner";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
const NewsDetail = () => {
  const [innovation, setInnovation] = useState<InnovationDataType | null>(null);
  const lang = useLang();
  const language = useSelector((state: RootState) => state.language.language);
  const { category, slug } = useParams<{ category: string; slug: string }>();
  const [loading, setLoading] = useState(true);
  const [localizedUrls, setLocalizedUrls] = useState<{
    az: string;
    en: string;
    ru: string;
  } | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (slug && category) {
      InnovationServices.GetInnovationBySlug(category, slug)
        .then((res) => {
          if (res.status === 200) {
            setInnovation(res.data);
            setLocalizedUrls({
              az: res.data.url_az,
              en: res.data.url_en,
              ru: res.data.url_ru,
            });
          }
        })
        .catch((err) => console.error("Fetch error", err))
        .finally(() => setLoading(false));
    }
  }, [slug, category]);

  useEffect(() => {
    if (localizedUrls) {
      const targetUrl = localizedUrls[language as "az" | "en" | "ru"];
      const currentUrl = `${category}/${slug}`;

      if (targetUrl && currentUrl !== targetUrl) {
        navigate(`/${lang}/${targetUrl}`, { replace: true });
      }
    }
  }, [language, localizedUrls, navigate, slug, category]);

  if (loading)
    return (
      <div>
        <Spinner size="large" />
      </div>
    );

  return (
    <div className={styles.NewsAll}>
      <div className="container">
        <div className={styles.newsTitle}>
          <h1>{innovation?.title}</h1>
        </div>
        <div className={styles.newsImage}>
          <img
            src={`https://backend.colibri.az${innovation?.image}`}
            alt={innovation?.title}
          />
        </div>
        <div className={styles.newsDescription}>
          <div
            className={styles.newsDescriptionContent}
            dangerouslySetInnerHTML={{ __html: innovation?.description || "" }}
          />
        </div>
      </div>
      <MobileAppSection />
    </div>
  );
};

export default NewsDetail;
